import SEO from "../components/SEO";
import { useMobileOptimization } from "../utils/useMobileOptimization";

export default function Contact() {
  const { isMobile } = useMobileOptimization();

  return (
    <>
      <SEO
        title="Contact"
        description="Get in touch with Nathan Portelli for inquiries regarding exhibitions, acquisitions, or press. Contact information and social media links."
        url="https://nathanportelli.com/contact"
      />
      <div className="mt-10 ml-5 w-full flex flex-col animate-fadeInUp max-md:ml-0 max-md:w-full max-md:overflow-x-hidden">
        <h2 className="text-xl font-normal m-0 mb-8 tracking-wide">Contact</h2>

        <div className="max-w-2xl mt-8">
          <div className="flex flex-col py-4 border-b border-gray-100">
            <span className="text-sm text-gray-600 mb-1 tracking-wide">
              Email
            </span>
            <a
              href="mailto:portellinate@gmail.com"
              className="text-base tracking-wide text-black no-underline transition-opacity duration-200 hover:opacity-60"
            >
              portellinate@gmail.com
            </a>
          </div>
          <div className="flex flex-col py-4 border-b border-gray-100">
            <span className="text-sm text-gray-600 mb-1 tracking-wide">
              Phone
            </span>
            <a
              href="tel:+35679301948"
              className="text-base tracking-wide text-black no-underline transition-opacity duration-200 hover:opacity-60"
            >
              +356 79301948
            </a>
          </div>
        </div>

        <div className="mt-15 max-w-2xl mb-5">
          <h3 className="text-lg font-normal m-0 mb-5 tracking-wide">Follow</h3>
          <div className="flex gap-5">
            <a
              href="https://www.instagram.com/nathanportelliart"
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center justify-center w-10 h-10 border border-gray-200 rounded-full text-black no-underline transition-all duration-200 ${
                !isMobile
                  ? "hover:bg-black hover:text-white hover:-translate-y-0.5 hover:shadow-lg"
                  : "hover:bg-black hover:text-white"
              } relative overflow-hidden`}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                  rx="5"
                  ry="5"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="m16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="17.5"
                  y1="6.5"
                  x2="17.51"
                  y2="6.5"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/nathanportelliart"
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center justify-center w-10 h-10 border border-gray-200 rounded-full text-black no-underline transition-all duration-200 ${
                !isMobile
                  ? "hover:bg-black hover:text-white hover:-translate-y-0.5 hover:shadow-lg"
                  : "hover:bg-black hover:text-white"
              } relative overflow-hidden`}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
